import React, { Fragment, ReactElement, useState } from 'react';
import Styles from './PatientAppointment.module.scss';
import ModalPopUp from '../ModalPopUp/ModalPopUp';
import ButtonPair from '../Buttons/ButtonPair';
import HeaderTitle from "./HeaderTitle";
import calendar from '../../images/ImagesSA/PatientAppoitment/calendar.png';
import person from '../../images/ImagesSA/Dependent/person.png';
import DynamicTable from '../../Tables/DynamicTable';
import { Dependant, Patient, PatientRequest } from "../../store/medicalAppointment/types";
import { connect } from "react-redux";
import { postUserAppointment } from "../../store/medicalAppointment/thunks";
import { ConvertValueRelationship } from '../Parameters/ConvertValuesParameter';
import { getToken } from '../User/Auth';

interface PatientAppointmentProps{
    closePopUp: any,
    dependentList?: Dependant[] | null,
    postUserAppointment: any,
    errorMessage: ReactElement,
    setMessage: any
}

const PatientAppointment: React.FC<PatientAppointmentProps> = (props: PatientAppointmentProps) => {
    const dataHeader: string[] = ["Nombres", "Apellidos", "Parentesco", "Seleccionar"];
    const dataContent =
        props.dependentList?.map(({ identification, firstName, lastName, relationship }) =>
        ({ identification, firstName, lastName, relationship }));

    const [selectedPatients, setSelectedPatients] = useState<PatientRequest[]>([]);
    let patients: Patient[] = [];
    dataContent?.map((item) => { patients.push({
                                                identification: item.identification,
                                                firstName: item.firstName,
                                                lastName :  item.lastName,
                                                relationShip: item.relationship,
                                              });
    });

     const GenerarCeldaTabla = (val: any, cont: number, patient: Patient): ReactElement => {
         let cell: ReactElement =
            cont === 4 ?
                <Fragment>
                    <td>{ConvertValueRelationship(val)}</td>
                    <td>
                        <input
                             type="checkBox"
                             onChange = {(event) => selectPatient(event, patient)}
                        />
                    </td>
                 </Fragment>
                 :
                 cont === 0 || cont === 1 ?
                 <td style={{ display: "none" }}>{val}</td>
                 :
                 <td>{val}</td>
        return cell;
    }

    const selectPatient = (ev: React.ChangeEvent<HTMLInputElement>, patient: Patient) => {
        let patientRequest: PatientRequest[] | undefined = selectedPatients;
        const patients : PatientRequest = {identification:patient.identification};
        if (ev.target.checked) {
                patientRequest?.push( //no pueden haber dos dependientes con la misma identificación
                    patients
                );
                setSelectedPatients(patientRequest);
            }
        else {
            let result: PatientRequest[] | undefined = patientRequest?.filter(item => item.identification !== patient.identification);
            const exists = result === null || undefined ? 0 : result?.length;
             if (!(exists === 0 || exists === undefined)) {
                 if (!ev.target.checked) {
                     setSelectedPatients(result);
                 }
             }
             else {
                if (selectedPatients.length === 1)
                {
                    setSelectedPatients([]);
                }
            }
         }
    }
    const content = patients?.map((item) => {
        let cont = 0;
        return (
            <tr key={item.firstName}>
                {Object.values(item).map((val) => (
                    GenerarCeldaTabla(val, cont = cont + 1, item)
                ))}
            </tr>
        )
    });

    const next = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        var jwt = require('jsonwebtoken');
        var decoded = jwt.decode(getToken());
        if (selectedPatients.length>0){
            const response = await props.postUserAppointment(selectedPatients);
            if (response.StatusCode.toString() === "200") {
                window.location.href = 'https://www.instasalud.com/virtualmentejuntos? númeroDocumento='+ decoded.identification;            }
        }
        else
        {
            props.setMessage(["Debe seleccionar un paciente"]);
        }
    }

    return (
        <Fragment>
            <ModalPopUp classNameStyle="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <div className={Styles.scroll}>
                    <HeaderTitle
                            title="Agendamiento de citas"
                            image={<img src={calendar}
                            alt="Agendamiento de citas" />}
                    />
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                            <sub className={Styles.parrafo}>Si deseas agendar una cita por favor señala a
                            las personas que necesitan la cita de presiona "Agendar cita(s)"</sub>
                        </div>
                    </div>
                    <div className="row mb-3 mt-2 text-left">
                        <div className=" col-lg-auto col-md-auto col-sm-auto col-xs-12">
                            <img src={person} className="img-fluid" alt="Imagen Persona" />
                        </div>
                        <div className=" col-lg-10 col-md-10 col-sm-10 col-xs-12 pt-2 pl-4">
                            <p className={Styles.subTitle}>
                                Pacientes
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <DynamicTable dataHeader={dataHeader}>
                                <Fragment>{content}</Fragment>
                            </DynamicTable>
                        </div>
                    </div>
                    <div className="mt-3">
                        <ButtonPair
                            idNext="btnNext"
                            idPrevious="btnPrevious"
                            onClickNext={next}
                            onClickBack={() => props.closePopUp('appoitmemt')}
                            textoButtonBack="Cancelar"
                            textoButtonNext="Agendar cita(s)"
                            styleClass=""
                            minWidth="10rem"
                            maxWidth="10rem"
                        />
                    </div>
                    <div className="mt-3">
                         {props.errorMessage}
                    </div>
                </div>
            </ModalPopUp>
         </Fragment>
    );
};
export default connect(null, { postUserAppointment })(PatientAppointment);
